module.exports = __webpack_public_path__ + "img/banner-3-3@2x.536aba1f.jpg";